// extracted by mini-css-extract-plugin
export default {"auftragCard":"auftragterminierencomponent_auftragCard__B6fzt","pille":"auftragterminierencomponent_pille__MdNMb"};